// @ts-nocheck
import React, { Component } from 'react';
import styled from 'styled-components';
import { formatUtc } from '../../lib/date/dayjs';
import isEmpty from 'lodash/isEmpty';
import notification from 'antd/lib/notification';
import { Link } from '../../lib/routerAdapter';
import Button from 'antd/lib/button';
import { navigate } from '../../lib/routerAdapter';
import qs from 'query-string';
import { getListInitialState, setQueryParams } from './../../lib/helpers';
import { businessDayTypes } from './../../lib/enum';
import { businessDayApi } from './../../lib/api';
import { Panel, Section } from './../../components/layout';
import { Popconfirm, Table, Icon, Operations } from './../../components/ui';
import Header from './../../components/layout/Header';
import Breadcrumbs, { Crumb } from './../../components/layout/Breadcrumbs';
import { notificationLoading } from './../../components/Notifications';
const StyledPanel = styled(Panel).withConfig({
  displayName: "List__StyledPanel",
  componentId: "sc-17a5pf7-0"
})(["padding-top:0;"]);
const StyledIcon = styled(Icon).withConfig({
  displayName: "List__StyledIcon",
  componentId: "sc-17a5pf7-1"
})(["cursor:pointer;"]);
class BusinessCalendar extends Component {
  state = getListInitialState();
  fetchBusinessDays = async (page = 1, params = {}) => {
    this.setState({
      loading: true
    });
    const {
      data,
      totalCount
    } = await businessDayApi.fetchBusinessDays({
      page,
      orderBy: 'date',
      byDescending: true,
      ...params
    });
    setQueryParams({
      page
    });
    this.setState({
      loading: false,
      data,
      totalCount,
      page
    });
  };
  onDelete = async id => {
    const {
      page
    } = this.state;
    try {
      notificationLoading({
        message: 'Удаление...',
        key: 'deleting'
      });
      await businessDayApi.deleteBusinessDay(id);
      await this.fetchBusinessDays(page);
    } catch (err) {
      notification.error({
        message: 'Ошибка',
        description: err.message
      });
    } finally {
      notification.destroy('deleting');
    }
  };
  columns = [{
    title: 'Дата',
    dataIndex: 'date',
    sorter: true,
    render: date => formatUtc(date, 'DD.MM.YYYY')
  }, {
    title: 'Тип',
    dataIndex: 'dayType',
    sorter: true,
    render: dayType => businessDayTypes[dayType]
  }, {
    title: 'Описание',
    dataIndex: 'description'
  }, {
    title: '',
    width: 30,
    render: record => isEmpty(record) ? null : <Operations>
            <Popconfirm title="Вы действительно хотите удалить?" okText="Да" cancelText="Нет" onConfirm={() => this.onDelete(parseInt(record.id))}>
              <StyledIcon type="x" />
            </Popconfirm>
          </Operations>
  }];
  handleRowClick = id => navigate(`/admin/business-calendar/${id}`);
  async componentDidMount() {
    const {
      page
    } = qs.parse(window.location.search);
    await this.fetchBusinessDays(page);
  }
  render() {
    const {
      location
    } = this.props;
    const {
      data,
      totalCount,
      pageSize,
      page,
      loading
    } = this.state;
    return <>
        <Header left={<Breadcrumbs>
              <Crumb to="/">Главная</Crumb>
              <Crumb>Производственный календарь</Crumb>
            </Breadcrumbs>} right={<Link to={`/admin/business-calendar/new`}>
              <Button type="primary">Создать</Button>
            </Link>} />
        <StyledPanel>
          <h1>Производственный календарь</h1>
        </StyledPanel>
        <Section>
          <Table onRow={record => ({
          onClick: () => this.handleRowClick(record.id)
        })} columns={this.columns} fetch={this.fetchBusinessDays} loading={loading} data={data.map(item => ({
          ...item,
          key: item.id
        }))} pagination={{
          page,
          totalCount,
          pageSize,
          location
        }} />
        </Section>
      </>;
  }
}
export default BusinessCalendar;
